module.exports = __webpack_public_path__ + "img/9.f337c690.jpg";